import toast from "react-hot-toast";
import axiosInstance from "./Axios";
import { clientRoutes } from "../routes";

export class PropertyApi {
  static hashtags = async () => {
    try {
      const res = await axiosInstance.get(`hashtags`, {
        params: {
          page: 1,
          limit: 30,
          created_at: "desc",
          search: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAgents = async (search: string = "") => {
    try {
      const res = await axiosInstance.get(`client/agents`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: search,
          agency_id: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAgency = async () => {
    try {
      const res = await axiosInstance.get(`admin/agency`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: "",
          agency_id: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getSeperateProperties = async ({
    page,
    limit = 30,
    search,
    listing_type,
    agents_id,
    property_stage_id,
    property_type_id,
    start_date,
    end_date,
  }: {
    page: number;
    limit?: number;
    search: string;
    listing_type: string;
    agents_id: string;
    property_stage_id: string;
    property_type_id: string;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `properties/get-seperate-properties`,
        {
          params: {
            page,
            limit,
            created_at: "desc",
            search,
            property_stage_id,
            agent_id: agents_id,
            property_type_id,
            listing_type,
            duration_start_date: start_date,
            duration_end_date: end_date,
          },
        },
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPostProperties = async ({
    page,
    limit = 30,
    search,
    listing_type_id,
    agents_id,
    property_stage_id,
    property_type_id,
    start_date,
    end_date,
  }: {
    page: number;
    limit?: number;
    search: string;
    listing_type_id: string;
    agents_id: string;
    property_stage_id: string;
    property_type_id: string;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(`properties`, {
        params: {
          page,
          limit: 15,
          created_at: "desc",
          search,
          property_stage_id,
          agent_id: agents_id,
          property_type_id,
          listing_type: listing_type_id,
          duration_start_date: start_date,
          duration_end_date: end_date,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getProperties = async ({
    page,
    search,
    agency_id,
    agent_id,
    status,
    listing_type_ids,
    property_stage_ids,
    selected_city_ids,
    selected_state_ids,
    property_type_ids,
    selected_country_ids,
    start_date,
    end_date,
  }: {
    page: number;
    search: string;
    agency_id: string;
    agent_id: string;
    status: string;
    listing_type_ids: string;
    property_stage_ids: string;
    selected_city_ids: string;
    selected_state_ids: string;
    property_type_ids: string;
    selected_country_ids: string;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/properties/list`, {
        params: {
          page,
          limit: 30,
          created_at: "desc",
          search,
          agency_id,
          agent_id,
          status,
          listing_type: listing_type_ids,
          property_stage_id: property_stage_ids,
          city: selected_city_ids,
          state: selected_state_ids,
          property_type_id: property_type_ids,
          country: selected_country_ids,
          duration_start_date: start_date,
          duration_end_date: end_date,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAgencyOpenHomeScheduleById = async (schedule_id: string) => {
    try {
      const res = await axiosInstance.get(
        `agency-open-home-schedules/${schedule_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateOpenHomeScheduleForAgency = async (
    agency_open_home_schedule_id: string,
    data: any,
  ) => {
    try {
      const res = await axiosInstance.put(
        `agency-open-home-schedules/${agency_open_home_schedule_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static deleteOpenHomeProperty = async (open_home_property_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `/open-home-schedules/open-home-properties/${open_home_property_id}`,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getTemplateConfigs = async ({
    subscription_type,
    listing_type,
  }: {
    subscription_type: string;
    listing_type: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/template-configs`,

        {
          params: {
            listing_type,
            subscription_type,
          },
        },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getDesignTemplateById = async (templateId: string) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/design_templates/${templateId}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAuctions = async (
    params: {
      start_date?: string;
      end_date?: string;
      status?: string;
      post_status?: string;
      property_id?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/get-auctions`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getAuctionScheduleById = async (auction_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/get-auction/${auction_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateAuctionPost = async (data: any, auction_id: string) => {
    try {
      const res = await axiosInstance.put(`admin/auction/${auction_id}`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static GetReviewPosts = async (
    params: {
      page?: number;
      limit?: number;
      review_post_title?: string;
      post_status?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/get-review-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetOnboardingPosts = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
      schedule_start?: string;
      schedule_end?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/get-onboarding-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetAnnouncementPosts = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
      schedule_start?: string;
      schedule_end?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/get-announcement-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetReviewPostById = async (review_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/review-post/${review_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetOnboardingPostById = async (onboarding_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/onboarding-post/${onboarding_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetAnnouncementPostById = async (announcement_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/announcement-post/${announcement_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateReviewPost = async (data: any, review_post_id: string) => {
    try {
      const res = await axiosInstance.put(
        `admin/update-review-post/${review_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateOnboardingPost = async (
    data: any,
    onboarding_post_id: string,
  ) => {
    try {
      const res = await axiosInstance.put(
        `admin/update-onboarding-post/${onboarding_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateAnnouncementPost = async (
    data: any,
    announcement_post_id: string,
  ) => {
    try {
      const res = await axiosInstance.put(
        `admin/update-announcement-post/${announcement_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static GetScheduleOpenHome = async (
    params: {
      start_date?: string;
      end_date?: string;
      post_status?: string;
      property_ids?: string;
      post_type?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/get-open-home-list`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getCombinedOpenHomeSchedules = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      post_type?: string;
      agency_ref?: string;
      agent_ref?: string;
      property_id?: string;
      property_ids?: string;
      open_home_date?: string;
      start_date?: string;
      end_date?: string;
      search?: string;
      filter_date_by?: "open_home_date" | "createdAt";
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`admin/open-home-list/combined`, {
        params: params,
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getCombinedOpenHomeScheduleById = async (scheduleId: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/open-home/combined/${scheduleId}`,
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Failed to fetch schedule details.",
        data: err?.response?.data,
      };
    }
  };

  static getOpenHomeScheduleById = async (schedule_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/open-home/${schedule_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateOpenHomePost = async (
    open_home_schedule_id: string,
    data: any,
  ) => {
    try {
      const res = await axiosInstance.put(
        `admin/update-open-home/${open_home_schedule_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static imagesUpload = async (data: any) => {
    try {
      const res = await axiosInstance.post(`properties/images/upload`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyPosts = async (
    params: {
      start_date?: string;
      end_date?: string;
      status?: string;
      property_id?: string;
      agent_ref?: string;
      agency_ref?: string;
      page?: number;
      limit?: number;
      search?: string;
      created_at?: "asc" | "desc";
      subscription_type?: string | string[];
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `admin/property-post/get-property-posts`,
        {
          params: {
            ...params,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyPostById = async (propertyPostId: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/property-post/${propertyPostId}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static deleteImage = async (image_id: string) => {
    try {
      const res = await axiosInstance.delete(`properties/images/${image_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getSelectors = async () => {
    try {
      const res = await axiosInstance.get(`properties/selectors`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createPropertie = async (data: any) => {
    try {
      const res = await axiosInstance.post(`properties`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getPropertieById = async (property_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/properties/${property_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getPropertieStages = async () => {
    try {
      const res = await axiosInstance.get(`property-stages`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertie = async (data: any, property_id: string) => {
    try {
      const res = await axiosInstance.put(`properties/${property_id}`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static deleteProperty = async (property_id: string) => {
    try {
      const res = await axiosInstance.delete(`properties/trash/${property_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyBankList = async ({
    page,
    limit = 30,
    search,
    agency_id,
    agent_id,
    status,
    property_type_ids,
    selected_city_ids,
    selected_state_ids,
    selected_country_ids,
    start_date,
    end_date,
  }: {
    page: number;
    limit?: number;
    search: string;
    agency_id: string;
    agent_id: string;
    status: string;
    property_type_ids: string;
    selected_city_ids: string;
    selected_state_ids: string;
    selected_country_ids: string;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/property_bank/list`, {
        params: {
          page,
          limit,
          created_at: "desc",
          search,
          agency_id,
          agent_id,
          status,
          property_type_id: property_type_ids,
          city: selected_city_ids,
          state: selected_state_ids,
          country: selected_country_ids,
          duration_start_date: start_date,
          duration_end_date: end_date,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createPropertyBank = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/property_bank/create`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyBankById = async (id: string) => {
    try {
      const res = await axiosInstance.get(`admin/property_bank/${id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertyBank = async (id: string, data: any) => {
    try {
      const res = await axiosInstance.post(`admin/property_bank/${id}`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };
}
